import Vue from "vue";
let currentRequest = 0;

const GenerationSessionService = {
  async fetchOne(id) {
    if (id == null) {
      return null;
    }
    try {
      const data = await Vue.$jsonApi.find("generation_session", id, {
        include: "user"
      });
      return data.data[0];
    } catch (error) {
      console.log("fetchOne error: ", error);
      return { error: error };
    }
  },
  async fetchAll(searchFilterPagination) {
    try {
      const request = ++currentRequest;
      console.log(`[${request}] START GENERATION_SESSION `, searchFilterPagination.search);
      const res = await Vue.$jsonApi.findAll(
        "generation_session",
        searchFilterPagination
      );
      if (request !== currentRequest) {
        console.log(`[${request}] GENERATION_SESSION DISCARDED`);
        return null;
      }
      console.log(`[${request}] END GENERATION_SESSION `, searchFilterPagination.search);
      return res;
    } catch (error) {
      console.log("fetchAll error: ", error);
      return { error: error };
    }
  },
  async createOrUpdate(payload) {
    try {
      if (payload.id == "" || payload.id == null) {
        return await Vue.$jsonApi.create("generation_session", payload);
      } else {
        return await Vue.$jsonApi.update("generation_session", payload);
      }
    } catch (error) {
      console.log("createOrUpdate error: ", error);
      return { error: error };
    }
  },
  async delete(id) {
    if (id == null) {
      return null;
    }
    try {
      const data = await Vue.$jsonApi.destroy("generation_session", id);
      return data;
    } catch (error) {
      console.log("delete error: ", error);
      return { error: error };
    }
  }
};

export { GenerationSessionService };
